import { ChangeEvent } from "react";

import Dropdown from "../../basic/dropdown";
import style from "./styles.module.scss";
import { Props } from "./types";

export default function ToggleColumnsDropdown<T>(props: Props<T>) {
	function visibleCheckChange(event: ChangeEvent<HTMLInputElement>) {
		const index = parseInt(event.target.getAttribute("data-index"));
		props.updateVisibility(index, event.target.checked);
	}
	return (
		<Dropdown buttonText={"Show/Hide Columns"}>
			<ul className={style.columnList}>
				{props.columns.map((column, index) => (
					<li key={index}>
						<label>
							<input
								type="checkbox"
								onChange={visibleCheckChange}
								data-index={index}
								checked={column.visible}
							/>{" "}
							{column.name}
						</label>
					</li>
				))}
			</ul>
		</Dropdown>
	);
}
